<template>
    <UButton
          variant="solid"
          class="justify-center py-4"
          icon="i-heroicons-credit-card"
          :to="localePath('checkout')"
          size="lg"
          :label="$t('Checkout')"
          color="primary" />
</template>
<script setup lang="ts">
    const localePath = useLocalePath()
</script>